<script>
	import ContentPage from '@/components/pages/ContentPage'

	export default {
		name: 'FaqOverviewPage',
		extends: ContentPage
	}
</script>
